import React, { Component, createRef } from 'react';
import styled from 'styled-components';
import ioClient from 'socket.io-client';
import Peer from 'peerjs';
import CallController from '../Components/CallController';
import ChatRoom  from '../Components/ChatRoom';
import FloatingChatInput from '../Components/FloatingChatInput';
import {firestore} from '../Utils/config';
import {ConfigContext} from '../Context/ConfigContext';

const VideoContainer = styled.div`
    width: 100%;
    height: 100vh;
    background: #111111;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
`;

const RemoteVideoContainer = styled.div`
    height: 100vh;
    display: flex;
    width: 60%;
    flex-wrap: wrap;
`;

const LocalVideoAndController = styled.div`
    height: 100vh;
    display: flex;
    width: 40%;
    flex-wrap: wrap;
    overflow: hidden;
`;

const StyledVideo = styled.video`
    width: ${props => props.width === 'full' ? '100%' : '100%'};
    height: ${props => props.width === 'full' ? '60%' : 'auto'};
    background: #444444;
`;


class Room extends Component {
    static contextType = ConfigContext;
    state = {
        roomid: null,
        peer: null,
        localId: null,
        localstream: null,
        connection: null,
        remoteId: null,
        chatInputBoxToggle: false,
        isAudio: false,
        isVideo: false
    }

    localVideoRef = createRef();
    remoteVideoRef = createRef();
    io = ioClient('https://aqueous-brushlands-23949.herokuapp.com/',{transports: ['websocket']});

    async componentDidMount() {
        const mediaConfig = this.context;
        this.setState({isAudio: mediaConfig.state.isAudio,isVideo: mediaConfig.state.isVideo});
        console.log("Config Context Render",mediaConfig);
        const { roomid } = this.props.match.params;
        this.setState({ roomid })

        const myPeer = new Peer(undefined,{
            config: {
              iceServers: [
                {
                  urls: ["turn:3.142.141.201:3478"],
                  username: "admin",
                  credential: "12345",
                },
              ],
            },
          });

        this.setState({ peer: myPeer })


        const firebaseMeetingRef = firestore.collection("meetings")
        .doc("mId_"+this.props.match.params.room);

        firebaseMeetingRef.onSnapshot((doc) => {
            // do stuff with the data
            console.log(doc.data());
        });

        myPeer.on('open', async id => {
            this.io.emit("join-room", roomid, id);
            this.setState({ localId: id });

            const meetingSnapshot = await firebaseMeetingRef.get();
            if(!meetingSnapshot.exists) {
                firebaseMeetingRef.set({
                    meetingHost: "ibrahim",
                    messages: [],
                    attendee: [id],
                })
            }else{
                const meeting = await firebaseMeetingRef.get();
                console.log("Local",id);
                firebaseMeetingRef.set({
                    ...meeting.data(),
                    attendee: [...meeting.data().attendee,id]
                })
            }
        });

        

        navigator.mediaDevices.getUserMedia({
            video: mediaConfig.state.isVideo,
            audio: mediaConfig.state.isAudio
        }).then(stream => {
            this.addVideoStream(this.localVideoRef, stream);
            myPeer.on("call", call => {
                call.answer(stream);
                call.on("stream", userVideoStream => {
                    this.addVideoStream(this.remoteVideoRef, userVideoStream);
                });
            });

            this.setState({ localstream: stream })

            this.io.on("user-connected", userid => {
                this.setState({ remoteId: userid });
                this.io.emit("other-user", this.state.roomid, this.state.localId);
                this.connectToNewUser(userid);

            });

            this.io.on("other-user-info", id => {
                if (this.state.remoteId === null) {
                    this.setState({ remoteId: id });
                }
            });

        });

    }

    addVideoStream = (vidRef, stream) => {
        vidRef.current.srcObject = stream;
        vidRef.current.addEventListener("loadedmetadata", () => {
            vidRef.current.play();
        });
    }

    connectToNewUser = (userid) => {
        const call = this.state.peer.call(userid, this.state.localstream);
        call.on("stream", userVideoStream => {
            this.addVideoStream(this.remoteVideoRef, userVideoStream);
        });
        call.on("close", () => {
            this.remoteVideoRef.current.remove();
        });
    }

    getDisplayStream = async (e) => {
        const stream = await window.navigator.mediaDevices.getDisplayMedia();
        const [videoTrack] = stream.getVideoTracks();
        const mainStream = await window.navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        const [audioTrack] = mainStream.getAudioTracks();
        const newStream = new MediaStream([videoTrack, audioTrack]);


        stream.oninactive = async () => {
            const camStream = await window.navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            this.addVideoStream(this.localVideoRef, camStream);
            this.state.peer.call(this.state.remoteId, camStream);
        }

        this.setState((prev) => prev.localstream = newStream);
        this.addVideoStream(this.localVideoRef, this.state.localstream);
        this.state.peer.call(this.state.remoteId, this.state.localstream);
    }

    handleChatInputToogle = (e) => {
        this.setState({chatInputBoxToggle: !this.state.chatInputBoxToggle})
    }

    handleSendMessage = async (message) => {
        console.log(message);
        const firebaseMeetingRef = firestore.collection("meetings")
        .doc("mId_"+this.props.match.params.room);

        const meetingInfo = await firebaseMeetingRef.get();
        firebaseMeetingRef.set({
            ...meetingInfo.data(),
            messages: [...meetingInfo.data().messages,{data: message,user_id: this.state.localId}]
        })
    }

    render() {
        return (
            <VideoContainer>
                <RemoteVideoContainer>
                    <StyledVideo ref={this.remoteVideoRef} width="full"></StyledVideo>
                    <CallController 
                        chatInputToggle={this.state.chatInputBoxToggle}
                        handleChatInputToogle={this.handleChatInputToogle}
                        displayStream={this.getDisplayStream}
                    />
                </RemoteVideoContainer>
                <LocalVideoAndController>
                    <ChatRoom localUserId={this.state.localId}/>
                    <StyledVideo muted ref={this.localVideoRef} width="fixed"></StyledVideo>
                </LocalVideoAndController>
                {this.state.chatInputBoxToggle && 
                    <FloatingChatInput 
                        handleChatInputToogle={this.handleChatInputToogle}
                        handleSendMessage={this.handleSendMessage}
                    />
                }
            </VideoContainer>
        );
    }
}

export default Room;